module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-300-[40]39.482f143.woff2";